<template>
  <div>
    <cadastro-base
      :salvar="salvar"
      :is-modal="isCadastroModal"
      :cancelar-cadastro="fechar"
    >
      <template slot="conteudo">
        <b-row>
          <b-form-group class="col-12 my-0 pb-0">
            <b-form-checkbox
              v-model="form.ativo"
              checked="true"
              class="custom-control-primary"
              style="float:right"
              name="check-button"
              switch
              @change="mostrarConfirmacaoInativo"
            >
              <label style="font-size: 1rem">Usuário Ativo</label>
            </b-form-checkbox>
          </b-form-group>
        </b-row>
        <b-row class="mt-0">
          <b-form-group
            label="Nome Completo"
            class="col-md-6"
          >
            <validation-provider
              #default="{ errors }"
              rules="required"
              name="Nome Completo"
            >
              <b-form-input
                v-model="form.nomeCompleto"
                :state="errors.length > 0 ? false :null"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
          <b-form-group
            label="CPF"
            class="col-md-6"
          >
            <masked-input
              ref="cpf"
              v-model="form.cpf"
              :mask="constroiMascaraCpf"
              class="form-control"
              @blur.native="validaCpf"
            />
            <small class="text-danger">{{ erroValidacao.cpf }}</small>
          </b-form-group>
        </b-row>
        <b-row>
          <b-col>
            <telefone-celular
              class="mb-2"
              :value="form.telefoneContato"
              :mostrar-ramal="true"
            />
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="6">
            <departamento-select
              v-model="form.departamentos"
              :multiple="true"
            />
          </b-col>
          <b-col cols="4">
            <legend class="col-form-label pt-0">
              Data de admissão
            </legend>
            <validation-provider
              #default="{ errors }"
              name="Data de Admissão"
              rules="required"
            >
              <data-input
                id="inicioAtividade"
                ref="dataAdmissaoInput"
                v-model="form.dataAdmissao"
                :invalid="errors.length > 0 || erroValidacao.dataAdmissao == 'data inválida'"
                @change="validarData"
              />
              <small class="text-danger">{{ errors[0] || (erroValidacao.dataAdmissao == 'data inválida' ? 'Data inválida' : '') }}</small>
            </validation-provider>
          </b-col>
          <b-col cols="2">
            <legend
              tabindex="-1"
              class="bv-no-focus-ring col-form-label pt-0"
            >&nbsp;</legend>
            <b-form-checkbox
              v-model="form.rodizio"
              value="true"
              unchecked-value="false"
              style="margin-top: 0.7rem"
            >
              Participa de Rodízio
            </b-form-checkbox>
          </b-col>
        </b-row>
        <b-row class="mt-1">
          <b-col cols="6">
            <funcao-select
              v-model="form.funcao"
              @input="setMultiplasEquipes()"
            />
          </b-col>
          <b-col cols="6">
            <equipe-select
              :value="form.equipes"
              :multiple="multiplasEquipes"
              @input="setEquipe"
            />
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="6">
            <grupo-usuario-select
              v-model="form.grupo"
              :filtrar-por-tipo="true"
              :tipo-externo="false"
            />
          </b-col>
          <b-form-group
            label="Integração com Domínio"
            class="col-md-6"
          >
            <b-form-input v-model="form.codigoIntegracao" />
          </b-form-group>
        </b-row>
        <b-row>
          <b-col
            cols="12"
            style="display: flex; justify-content: space-between; align-items: center; flex-wrap: wrap;"
          >
            <div class="div-checkbox">
              <b-form-checkbox
                v-model="form.dispensaEntrega"
                value="true"
                unchecked-value="false"
                style="margin-top: 0.7rem"
              />
              <div>
                <legend style="font-size: 14px; margin-top: 0.7rem">
                  Pode Dispensar Entrega de Documentos</legend>
              </div>
              <div style="margin-top: 0.3rem; margin-left: 0.3rem">
                <i
                  v-b-tooltip.hover
                  :title="tooltipDispensa"
                  style="font-size: 0.65rem;"
                  class="question-icon"
                >
                  <font-awesome-icon
                    :icon="faQuestionCircle"
                  />
                </i>
              </div>
            </div>
            <div class="div-checkbox">
              <b-form-checkbox
                v-model="form.permissaoOmie"
                value="true"
                unchecked-value="false"
                style="margin-top: 0.7rem"
              />
              <div>
                <legend style="font-size: 14px; margin-top: 0.7rem">
                  Pode Integrar com a Omie</legend>
              </div>
              <div style="margin-top: 0.3rem; margin-left: 0.3rem">
                <i
                  v-b-tooltip.hover
                  :title="tooltipIntegracao"
                  style="font-size: 0.65rem;"
                  class="question-icon"
                >
                  <font-awesome-icon
                    :icon="faQuestionCircle"
                  />
                </i>
              </div>
            </div>

            <div class="div-checkbox">
              <b-form-checkbox
                v-model="form.permissaoGClick"
                value="true"
                unchecked-value="false"
                style="margin-top: 0.7rem"
              />
              <div>
                <legend style="font-size: 14px; margin-top: 0.7rem">
                  Pode Integrar com a G-Click</legend>
              </div>
              <div style="margin-top: 0.3rem; margin-left: 0.3rem">
                <i
                  v-b-tooltip.hover
                  :title="tooltipIntegracao"
                  style="font-size: 0.65rem;"
                  class="question-icon"
                >
                  <font-awesome-icon
                    :icon="faQuestionCircle"
                  />
                </i>
              </div>
            </div>

            <div class="div-checkbox">
              <b-form-checkbox
                style="margin-top: 0.7rem"
              />
              <div>
                <legend style="font-size: 14px; margin-top: 0.7rem">
                  Pode Integrar com Acessórias</legend>
              </div>
              <div style="margin-top: 0.3rem; margin-left: 0.3rem" />
            </div>

            <div class="div-checkbox">
              <b-form-checkbox
                v-model="form.permissaoAlterarPropostaAprovada"
                value="true"
                unchecked-value="false"
                style="margin-top: 0.7rem"
              />
              <div>
                <legend style="font-size: 14px; margin-top: 0.7rem">
                  Pode Atualizar Proposta Aprovada</legend>
              </div>
              <div style="margin-top: 0.3rem; margin-left: 0.3rem">
                <i
                  v-b-tooltip.hover
                  :title="tooltipPropostaAprovada"
                  style="font-size: 0.65rem;"
                  class="question-icon"
                >
                  <font-awesome-icon
                    :icon="faQuestionCircle"
                  />
                </i>
              </div>
            </div>

            <div class="div-checkbox">
              <b-form-checkbox
                v-model="form.observacaoCertificado"
                value="true"
                unchecked-value="false"
                style="margin-top: 0.7rem"
              />
              <div>
                <legend style="font-size: 14px; margin-top: 0.7rem">
                  Observações nos Certificados</legend>
              </div>
              <div style="margin-top: 0.3rem; margin-left: 0.3rem">
                <i
                  v-b-tooltip.hover
                  :title="tooltipObsCertificado"
                  style="font-size: 0.65rem;"
                  class="question-icon"
                >
                  <font-awesome-icon
                    :icon="faQuestionCircle"
                  />
                </i>
              </div>
            </div>
            <div class="div-checkbox">
              <b-form-checkbox
                v-model="form.efetuaProcedimentos"
                value="true"
                unchecked-value="false"
                style="margin-top: 0.7rem"
              />
              <div>
                <legend style="font-size: 14px; margin-top: 0.7rem">
                  Procedimentos</legend>
              </div>
              <div style="margin-top: 0.3rem; margin-left: 0.3rem">
                <i
                  v-b-tooltip.hover
                  title="Ao marcar o check 'Procedimentos' o usuário terá permissão para incluir, alterar e remover os vídeos ou manuais de procedimentos."
                  style="font-size: 0.65rem;"
                  class="question-icon"
                >
                  <font-awesome-icon
                    :icon="faQuestionCircle"
                  />
                </i>
              </div>
            </div>
            <div class="div-checkbox">
              <b-form-checkbox
                v-model="form.docuSignResponsavel"
                value="true"
                unchecked-value="false"
                style="margin-top: 0.7rem"
              />
              <legend style="font-size: 14px; margin-top: 0.7rem">
                DocuSign (Responsável)</legend>
            </div>
            <div class="div-checkbox">
              <b-form-checkbox
                v-model="form.docuSignTestemeunha"
                value="true"
                unchecked-value="false"
                style="margin-top: 0.7rem"
              />
              <legend style="font-size: 14px; margin-top: 0.7rem">
                DocuSign (Testemunha)</legend>
            </div>
          </b-col>
        </b-row>

        <b-row>
          <b-col cols="12">
            <dados-acesso
              v-model="form.acessoUsuario"
              :erro-validacao="erroValidacao"
              :valida-login="validaLogin"
            />
          </b-col>
        </b-row>

        <b-row>
          <b-col
            v-if="form.nomeCompleto !== '' || form.acessoUsuario.alterarSenha"
            cols="12"
          >
            <dados-smtp
              :email="form.smtpEmail"
              :senha="form.smtpSenha"
              :user-id="$route.params.id"
              :validado="form.validado"
              :usuario-validou="form.usuarioValidou"
              :data-validacao="form.dataValidacao"
              :logado-google="form.logadoGoogle"
              :usar-google="form.usarGoogle"
              @input="setDadosSmtp"
              @email-google="iniciarLoginAutenticacao()"
              @sign-out="signOutGoogle()"
            />
          </b-col>
        </b-row>
      </template>
    </cadastro-base>
  </div>
</template>

<style lang="scss">
.div-checkbox {
  display: flex;
}
</style>

<script>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { ValidationProvider } from 'vee-validate'
import {
  required,
} from '@validations'
import { faQuestionCircle } from '@fortawesome/free-solid-svg-icons'
import { togglePasswordVisibility } from '@core/mixins/ui/forms'
import { initClientGoogle } from '@/shared/mixins/login-google/login-google'
import api from '@/app-modulo/comuns/usuario-interno/shared/services/api'
import apiEmail from '@/app-modulo/comuns/email-config/shared/services/api'
import CadastroBase from '@/shared/components/cadastro-base/CadastroBase.vue'

export default {
  name: 'UsuarioInterno',
  components: {
    CadastroBase,
    FontAwesomeIcon,
    ValidationProvider,
    FuncaoSelect: () => import('@/shared/components/funcao-select/FuncaoSelect.vue'),
    DepartamentoSelect: () => import('@/shared/components/departamento-select/DepartamentoSelect.vue'),
    GrupoUsuarioSelect: () => import('@/shared/components/grupo-usuario-select/GrupoUsuarioSelect.vue'),
    EquipeSelect: () => import('@/shared/components/equipe-select/EquipeSelect.vue'),
    DadosAcesso: () => import('@/shared/components/dados-acesso/DadosAcesso.vue'),
    DataInput: () => import('@/shared/components/data-input/DataInput.vue'),
    TelefoneCelular: () => import('@/shared/components/telefone-celular/TelefoneCelular.vue'),
    DadosSmtp: () => import('@/shared/components/dados-smtp/DadosSmtp.vue'),
  },
  mixins: [togglePasswordVisibility],
  props: {
    isCadastroModal: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      faQuestionCircle,
      required,
      state: 'none',
      form: {
        id: 0,
        nomeCompleto: '',
        cpf: '',
        dataAdmissao: '',
        funcao: null,
        equipes: null,
        departamentos: null,
        grupo: null,
        codigoIntegracao: null,
        ativo: true,
        efetuaProcedimentos: false,
        dispensaEntrega: false,
        permissaoOmie: false,
        permissaoGClick: false,
        permissaoAlterarPropostaAprovada: false,
        observacaoCertificado: false,
        smtpEmail: '',
        smtpSenha: '',
        validado: null,
        usuarioValidou: '',
        dataValidacao: '',
        acessoUsuario: {
          login: '',
          senha: '',
          alterarSenha: false,
        },
        telefoneContato: {
          telefoneWhatsApp: false,
          celularWhatsApp: false,
        },
        refreshToken: null,
        logadoGoogle: false,
        usarGoogle: false,
      },
      immutableForm: {},
      erroValidacao: { cpf: '', login: '', dataAdmissao: '' },
      multiplasEquipes: false,
      tooltipDispensa: `Ao marcar o check "Dispensar entrega de documentos" o usuário terá permissão para dispensar a entrega de documentos com status pendente e 
      recusado de todas as empresas e departamentos no portal de documentos.`,
      tooltipIntegracao: `Ao marcar o check "Pode Integrar com a Omie" o usuário terá permissão para realizar as 
      integrações com a Omie de empresas e propostas.`,
      tooltipPropostaAprovada: `Ao marcar o check o usuário terá permissão para alterar propostas com status Aprovada,
      adicionando serviços e alterando preços.`,
      tooltipObsCertificado: 'Quando marcado o usuário terá acesso ao campo observação no cadastro de certificados.',
    }
  },
  created() {
    this.state = this.$route.path.indexOf('editar') > 0 ? 'editar' : 'novo'
    if (this.state === 'editar') {
      this.carregar(this.$route.params.id)
    } else {
      this.form.acessoUsuario.alterarSenha = true
      apiEmail.configuradoGoogle()
        .then(payload => {
          this.form.usarGoogle = payload.data
        })
    }
  },
  methods: {
    carregar(id) {
      api.getUsuarioInterno(id)
        .then(payload => {
          this.form = payload.data
          this.multiplasEquipes = this.form.funcao !== null && this.form.funcao.gerente

          this.aplicaMascaras()
        })
    },
    salvar() {
      if (!this.erroValidacao.cpf && !this.erroValidacao.login && !this.erroValidacao.dataAdmissao) {
        return new Promise((resolve, reject) => {
          const form = { ...this.form }
          if (this.state === 'novo') {
            api.createUsuarioInterno(form)
              .then(() => {
                this.fechar()
                resolve('Usuário interno cadastrado com sucesso')
              })
              .catch(err => {
                reject(err)
              })
          } else {
            api.updateUsuarioInterno(this.form.id, form)
              .then(() => {
                this.fechar()
                resolve('Usuário interno alterado com sucesso')
              })
              .catch(err => {
                reject(err)
              })
          }
        })
      }
      if (this.erroValidacao.cpf) {
        this.$refs.cpf.$el.focus()
      } else if (this.erroValidacao.dataAdmissao) {
        this.$refs.dataAdmissaoInput.$el.focus()
      }

      return null
    },
    fechar() {
      if (this.$route.query && this.$route.query.newAba) {
        this.$router.push({ name: 'usuariosinternos' })
      } else {
        this.$router.go(-1)
      }
    },
    constroiMascaraCpf() {
      return [/\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '-', /\d/, /\d/]
    },
    constroiMascaraData() {
      return [/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/]
    },
    validaCpf() {
      if (this.form.cpf !== '') {
        const cpf = this.form.cpf ? this.form.cpf.replace(/\D/g, '') : ''
        api.validaCpf(this.form.id, cpf)
          .then(payload => {
            if (payload.data) {
              this.erroValidacao.cpf = 'CPF já existente'
            } else {
              this.erroValidacao.cpf = ''
            }
          })
      }
    },
    validaLogin() {
      if (this.state !== 'none' && this.form.acessoUsuario.login !== '') {
        api.validaLogin(this.form.id, this.form.acessoUsuario.login)
          .then(payload => {
            if (payload.data) {
              this.erroValidacao.login = 'Login já existente'
            } else {
              this.erroValidacao.login = ''
              if (this.state === 'novo') {
                this.form.smtpEmail = this.form.acessoUsuario.login
              }
            }
          })
      }
    },
    aplicaMascaras() {
      this.form.cpf = this.form.cpf ? (this.form.cpf).replace(/[^0-9]/g, '').replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4') : ''
    },
    setMultiplasEquipes() {
      this.form.equipes = (this.form.funcao !== null && this.form.funcao.gerente) ? this.form.equipes : []
      this.multiplasEquipes = this.form.funcao !== null && this.form.funcao.gerente
    },
    setEquipe(val) {
      this.form.equipes = []
      if (val.length !== 0) {
        if (this.multiplasEquipes) {
          this.form.equipes = val
        } else {
          this.form.equipes.push(val)
        }
      }
    },
    validarData(data) {
      if (data == null) {
        this.erroValidacao.dataAdmissao = 'data inválida'
      } else {
        this.erroValidacao.dataAdmissao = ''
      }
    },
    setDadosSmtp(dados) {
      this.form.smtpEmail = dados.smtpEmail
      this.form.smtpSenha = dados.smtpSenha
      this.form.validado = dados.validado
      this.form.usuarioValidou = dados.usuarioValidou
      this.form.dataValidacao = dados.dataValidacao
    },
    mostrarConfirmacaoInativo(value) {
      if (!value) {
        this.$swal({
          title: 'Deseja realmente inativar esse usuário?',
          text: 'Atenção: não serão geradas novas cobranças de documentos para as empresas vinculadas a esse usuário e as cobranças em tramitação '
           + 'no portal vinculadas a este usuário não gerarão novas notificações por e-mail. Somente voltará a notificar quando  efetuado a troca do '
           + 'responsável inativo por um ativo no cadastro de empresas.',
          confirmButtonText: 'Sim',
          cancelButtonText: 'Não',
          showCancelButton: true,
          focusConfirm: false,
          icon: 'question',
          customClass: {
            confirmButton: 'mr-1 w-25 btn-primary',
            cancelButton: 'w-25 btn-danger',
          },
        })
          .then(result => {
            if (result.value) {
              this.form.ativo = false
            } else {
              this.form.ativo = true
            }
          })
      }
    },
    iniciarLoginAutenticacao() {
      api.getClientGoogle()
        .then(payload => {
          initClientGoogle(this.loginGoogle, payload.data)
        })
    },
    loginGoogle(tokenResponse) {
      api.autenticarGoogle(this.$route.params.id ? this.$route.params.id : 0, tokenResponse.code, this.form.smtpEmail)
        .then(payload => {
          this.form.refreshToken = payload.data.refreshToken
          this.form.smtpEmail = payload.data.smtpEmail
          this.form.logadoGoogle = true
          this.$sucesso('Conectado com sucesso')
        })
        .catch(err => {
          this.$erro(err.message || err.response.data.message)
          throw err
        })
    },
    signOutGoogle() {
      api.logOutGoogle(this.$route.params.id)
        .then(payload => {
          if (payload.data) {
            this.form.logadoGoogle = false
            this.form.refreshToken = null
            this.$sucesso('Desconectado da conta')
          }
        })
        .catch(err => {
          this.$erro(err.message || err.response.data.message)
          throw err
        })
    },
  },
}
</script>
